/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import $ from 'jquery';
import profileObj from './profileObj';

export default class profileUtil {

    constructor(context) {
        this.name = "profileUtil";
        this.context = context;

        //Profile API
        this.api = "https://userprofileapi.blr.com";
        this.AuthenticationSystem = "MB";
        
    }

    getToken() {

        //getPreferences
        console.log("profileUtil: getToken");

        //let filter = encodeURI(JSON.stringify({ "where" : { "appId" : this.context.ApplicationId, "subId": this.context.subid(), "userId": this.context.user_ID()}}));
        let url = this.api + '/api/authenticate';
        let callData = JSON.stringify({ ClientID: this.context.profileClientID, ClientSecret: this.context.profileSecret });

        return new Promise((resolve, reject) => {

            $.ajax({
                url: url,
                method: 'POST',
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                data: callData
            }).done((response, textStatus, jqXHR) => {
                console.log("profileUtil:getToken: response: %o token: %o", response, jqXHR.getResponseHeader('Token'));
                this.context.profileToken = jqXHR.getResponseHeader('Token');
                resolve(response);
            })
            .fail((response, textStatus, errorThrown) => {
                console.log("profileUtil:getToken: ERROR: %o  errorThrown: %o", response, errorThrown);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error loading profile token"},"messageModel");
                reject(response);
            });

        });

    }    

    getProfile()
    {
        //getProfile
        console.log("profileUtil:getProfile with token: %o", this.context.profileToken);

        //let filter = encodeURI(JSON.stringify({ "where" : { "appId" : this.context.ApplicationId, "subId": this.context.subid(), "userId": this.context.user_ID()}}));
        let url = this.api + '/api/UserProfiles?' + "id=" + this.context.subid() + "&applicationId=" + this.context.ApplicationId;
        //let callData = JSON.stringify({ ClientID: this.profileClientID, ClientSecret: this.profileSecret });

        //let userProfileTypeId = 1;

        return new Promise((resolve, reject) => {

            $.ajax({
                url: url,
                method: 'GET',
                contentType: "application/json",
                headers: {
                    'Token': this.context.profileToken 
            },
            }).done((response, textStatus, jqXHR) => {
                console.log("profileUtil:getProfile: response: %o   jqXHR: %o", response, jqXHR);
                this.processProfile(response);
                resolve(response);
            })
            .fail((response, textStatus, errorThrown) => {
                console.log("profileUtil:getProfile: ERROR: %o  errorThrown: %o", response, errorThrown);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling getProfile"},"messageModel");
                reject(response);
            });

        });

    }
    

    processProfile(data)
    {
        //let appProfile = null;
        let profile = null;

        console.log("profileUtil:processProfile: data: %o", data);

        ko.utils.arrayForEach(data, item => {
            //Check for profile

            console.log("profileUtil:processProfile: ApplicationId: %o  ApplicationId: %o", item.ApplicationId, this.context.ApplicationId);
            if(item.ApplicationId == this.context.ApplicationId )
            {
                console.log("profileUtil:processProfile: profile found  item: %o", item);
                console.log("profileUtil:processProfile: profile found  profile: %o", item.UserProfileJSON);
                profile = new profileObj();
                profile.init(item);
                console.log("profileUtil:processProfile: profile found  profile: %o", profile);

                //set Profile to Global Object
                this.context.profileObject(profile.UserProfileJSON);

                console.log("profileUtil:processProfile:  context.profileObject: %o", this.context.profileObject());
                this.context.profileObject.valueHasMutated();
            }
        });

        //If No Profile load and save default
        if(profile === null)
        {  
            profile = new profileObj();
            this.context.profileObject(profile.setDefaultProfile());
        }

        console.log("profileUtil:processProfile: profile: %o", profile);

        if(profile.defaultLoaded)
        {
            console.log("profileUtil:processProfile: profile empty - Saving Default Profile");
            this.updateProfile(profile);
        }
        else if(profile !== null) 
        {
            console.log("profileUtil:processProfile: profile loaded");
            this.context.profileObject(profile.UserProfileJSON);
            this.context.profileObject.valueHasMutated();
        }
        else
        {
            console.log("profileUtil:processProfile: Saving Default Profile");
            profile = new profileObj();
            this.updateProfile(profile);
        }

        /*
        if((profile === null) && (appProfile !== null))
        {
            console.log("profileUtil:processProfile: appProfile loaded");
            this.context.profileObject(appProfile);
        }
        */

        console.log("profileUtil:processProfile: profileObject: %o", this.context.profileObject());

    }

    updateProfile(profile)
    {
        //getProfile
        console.log("profileUtil:updateProfile with token: %o", this.context.profileToken);
        console.log("profileUtil:updateProfile with profile: %o", profile);

        //let filter = encodeURI(JSON.stringify({ "where" : { "appId" : this.context.ApplicationId, "subId": this.context.subid(), "userId": this.context.user_ID()}}));
        let url = this.api + '/api/UserProfiles'
        let callData = { ApplicationId: this.context.ApplicationId,UserProfileTypeId: 1, UserId: this.context.subid(), Profile: this.context.subid(),  UserProfileJSON: JSON.stringify(profile.UserProfileJSON) };

        let userProfileTypeId = 1;

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: {
                    'Token': this.context.profileToken 
            },
            data: callData
            }).done((response, textStatus, jqXHR) => {
                console.log("profileUtil:updateProfile: response: %o  jqXHR: %o", response, jqXHR);
                //this.processProfile(response);
                resolve(response);
            })
            .fail((response, textStatus, errorThrown) => {
                console.log("profileUtil:updateProfile: ERROR: %o  errorThrown: %o", response, errorThrown);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling getProfile"},"messageModel");
                reject(response);
            });

        });

    }

}




// WEBPACK FOOTER //
// ./src/objects/profileUtil.js